<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>QUIENES SOMOS </h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                                :items-per-page="200">
                                <template v-slot:item.foto="{ item }">
                                    <v-img max-width="100" :src="item.foto"></v-img>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-app>
    </div>
</template>
<script>
import axios from "../../axios-auth";

export default {

    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        sector: "",
        listado: [],

        headers: [
            {
                text: "Foto",
                align: "center",
                sortable: false,
                value: "foto",
            },
            { text: "Nombre", sortable: false, value: "nombre" },
            { text: "Categoría", value: "profesion", sortable: false },
            { text: "Fecha de Ingreso", value: "f_ingreso", sortable: false },
            { text: "Fecha de Nacimienot", value: "f_nacim", sortable: false },
            { text: "Mail", value: "mail", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            const sector = this.sector;
            let self = this;

            axios
                .get("/RRHH/ListadoQuienessomos?", {
                    params: {
                        sector: sector,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },
    },
    beforeMount() {
        this.sector = this.$route.query.sector;
    },
};
</script>